import { render } from "./GuideCTA.vue?vue&type=template&id=4e98d2cc&scoped=true&ts=true"
import script from "./GuideCTA.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideCTA.vue?vue&type=script&setup=true&lang=ts"

import "./GuideCTA.vue?vue&type=style&index=0&id=4e98d2cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e98d2cc"],['__file',"src/lib/components/GuideCTA.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e98d2cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e98d2cc', __exports__)) {
    api.reload('4e98d2cc', __exports__)
  }
  
  module.hot.accept("./GuideCTA.vue?vue&type=template&id=4e98d2cc&scoped=true&ts=true", () => {
    api.rerender('4e98d2cc', render)
  })

}


export default __exports__